export class apiEvent{
  constructor(apiEventType, apiEvent){
    this.type = apiEventType
    this.message = apiEvent
    this.moment = Date.now()
  }
}